import React from 'react';
import PropTypes from 'prop-types';

import { Tracking } from 'bdvp-tracking';

import {
    TagsList,
    Tag,
    TagGroup,
    TagGroupLabel,
} from './Tags.style';

const Tags = ({
    removeFilter,
    selectedFilters,
}) => {

    if (!selectedFilters || selectedFilters.length < 1) return null;

    return (
        <TagsList>
            {selectedFilters.map((group, i) => (
                <TagGroup key={`${i}_${group.displayName}`}>
                    <TagGroupLabel>{`${group.displayName}`}</TagGroupLabel>
                    {group.values.map((filter, ix) => (
                        <Tag
                            key={`${i}-${ix}`}
                            label={filter.label}
                            size={'sm'}
                            iconName={'close'}
                            iconLeft={false}
                            handlers={{
                                onClick: () => {

                                    removeFilter(group.name, filter.value);
                                    Tracking.trackFilterTagRemoval();

                                },
                            }}
                        />
                    ))}
                </TagGroup>
            ))}
        </TagsList>
    );

};

Tags.propTypes = {
    removeFilter: PropTypes.func.isRequired,
    selectedFilters: PropTypes.array,
};

Tags.defaultProps = {
    selectedFilters: [],
};


// Prevent component from rendering unless check
export const shouldNotReRender = (prevProps, nextProps) => {

    if (nextProps.shouldNotReRender) {

        return true;

    }

    if (
        JSON.stringify(prevProps.selectedFilters) !== JSON.stringify(nextProps.selectedFilters)
        || prevProps.removeFilter !== nextProps.removeFilter
    ) {

        return false;

    }

    return true;

};

export default React.memo(Tags, shouldNotReRender);
